/**
 * add toast even if one of the same type already exists
 */
const TOAST_APPEND = 'event.toast.append';

/**
 * show toast if it doesn't already exist
 */
const TOAST_SHOW = 'event.toast.show';
const TOAST_HIDE = 'event.toast.hide';

const TOASTS = {
    TOAST_RESULT_LIMITS: 'ResultLimits',
    TOAST_COOKIE_CONSENT: 'Consent',
    TOAST_LOCALE_SELECT: 'Localeselect',
    TOAST_BROWSER_EXTENSION: 'Browserextension',
    TOAST_UNPUBLISHED_PAGE: 'UnpublishedPage',
    TOAST_RESULT_REMOVE_BACKGROUND: 'ResultRemoveBackground',
    TOAST_RESULT_PDFA_CONVERSION: 'ResultPDFAConversion',
    TOAST_RESULT_PDFA_VALIDATION: 'ResultPDFAValidation',
    TOAST_RESULT_OCR_HINT: 'ResultOCRHint',
    TOAST_RESULT_RESIZE_IMAGE: 'ResultResizeImage'
};

export { TOAST_APPEND, TOAST_SHOW, TOAST_HIDE, TOASTS };
